import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Link, Navigate, redirect } from "react-router-dom";
import {
  Autocomplete,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
// import Textarea from "@mui/joy/Textarea";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const fd = new FormData();
export default class ApproveQuestions extends Component {
  state = {
    allJobs: [],
    message: "",
    notification: false,
    limit: 1,
    page: 1,

    redirect: false,
    allSubjects: [],
    alltopics: [],
    allLevels: [],
    level_id: "",
    topic_id: "",
    level_name: "",
    question_type: "",
    testimonial: "",
    subject_id: "",
    search: "",
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    answer: "",
    id: "",
    questionApproved: false,
  };

  componentDidMount() {
    let page = window.location.pathname.split("/")[2];
    console.log(page);
    this.setState({ page: parseInt(page) }, () => {
      this.getSingleQuestion();
    });

    // this.getSingleQuestion();
  }

  getSingleQuestion = async () => {
    try {
      if (init() === "success") {
        const resp = await axios.get(
          Constants.getUrls.getAllQuestions +
            "?page=" +
            this.state.page +
            "&limit=" +
            this.state.limit
        );
        console.log(resp);
        this.setState(
          {
            question_type: resp.data.data?.docs[0].question_type,
            question: resp.data.data?.docs[0].question,
            option1: resp.data.data?.docs[0].option1,
            option2: resp.data.data?.docs[0].option2,
            option3: resp.data.data?.docs[0].option3,
            option4: resp.data.data?.docs[0].option4,
            answer: resp.data.data?.docs[0].answer,
            id: resp.data.data?.docs[0]._id,
            questionApproved: resp.data.data?.docs[0].approved_status === "approved" ? true : false,
          },
          () => {
            this.handleTopic();
            this.handleLevel();
          }
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  getAllSubjects = async () => {
    if (init() === "success") {
      await axios
        .get(Constants.getUrls.getAllSubjects + "?search=" + this.state.search)
        .then((resp) => {
          //   console.log(resp.data.data.docs);
          this.setState({
            allSubjects: resp.data.data.docs,
          });
        });
    }
  };

  handleTopic = async () => {
    if (init() === "success") {
      await axios
        .get(Constants.getUrls.getAllTopics + "?subject_id=" + this.state.subject_id)
        .then((resp) => {
          //   console.log(resp.data.data.docs);
          this.setState({
            alltopics: resp.data.data.docs,
          });
        });
    }
  };

  handleLevel = async () => {
    if (init() === "success") {
      await axios
        .get(
          Constants.getUrls.getAllLevels +
            "?subject_id=" +
            this.state.subject_id +
            "&topic_id=" +
            this.state.topic_id
        )
        .then((resp) => {
          //   console.log(resp.data.data.docs);
          this.setState({
            allLevels: resp.data.data.docs,
          });
        });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleNext = () => {
    let page = this.state.page + 1;
    this.setState({ page: page }, () => {
      this.getSingleQuestion();
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let payload = {
      subject_id: this.state.subject_id,
      level_id: this.state.level_id,
      topic_id: this.state.topic_id,
      question_type: this.state.question_type,
      question: this.state.question,
      option1: this.state.option1,
      option2: this.state.option2,
      option3: this.state.option3,
      option4: this.state.option4,
      answer: this.state.answer,
    };

    if (init() === "success") {
      axios
        .post(Constants.putUrls.approveQuestions + this.state.id, { approved_status: "approved" })
        .then((resp) => {
          console.log(resp);
          this.setState({
            notification: true,
            message: resp.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response?.data?.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    }
  };

  render() {
    if (this.state.redirect === true) {
      //   return <Navigate to="/questions" />;
    } else {
      return (
        <div>
          <div>
            <DashboardLayout>
              <DashboardNavbar />
              <MDBox pt={6} pb={3}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Approve Questions
                    </MDTypography>
                  </MDBox>
                  <Grid item sm={4} px={2} align="right">
                    <Link
                      to={{
                        pathname: "/updateQuestion/" + this.state.id,
                        // state: { data: job },
                      }}
                    >
                      <MDButton variant="contained" size="small" color="success">
                        Edit Question
                      </MDButton>
                    </Link>
                  </Grid>
                  <MDBox py={3} px={2}>
                    <form onSubmit={this.handleSubmit}>
                      <Grid container sm={12} spacing={2}>
                        {/* Select Question Type */}
                        <Grid item sm={6}>
                          <InputLabel>Select Question Type</InputLabel>
                          <Select
                            value={this.state.question_type}
                            onChange={(e) => this.setState({ question_type: e.target.value })}
                            name="question_type"
                            label="Select Subject"
                            // style={{
                            //   height: "45px",
                            // }}
                            required
                            style={{ width: "100%", height: "45px", color: "#111" }}
                          >
                            <MenuItem value="easy">Easy</MenuItem>
                            <MenuItem value="medium">Medium</MenuItem>
                            <MenuItem value="hard">Hard</MenuItem>
                          </Select>
                        </Grid>

                        <Grid item sm={12}>
                          <InputLabel>Question</InputLabel>
                          <TextField
                            type="text"
                            // label="Subject Name"
                            name="question"
                            value={this.state.question}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                          />
                        </Grid>

                        <Grid item sm={6}>
                          <InputLabel>Option 1</InputLabel>
                          <TextField
                            type="text"
                            // label="Subject Name"
                            name="option1"
                            value={this.state.option1}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>Option2</InputLabel>
                          <TextField
                            type="text"
                            // label="Subject Name"
                            name="option2"
                            value={this.state.option2}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>Option 3</InputLabel>
                          <TextField
                            type="text"
                            // label="Subject Name"
                            name="option3"
                            value={this.state.option3}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>Option 4</InputLabel>
                          <TextField
                            type="text"
                            // label="Subject Name"
                            value={this.state.option4}
                            name="option4"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                          />
                        </Grid>

                        <Grid item sm={6}>
                          <InputLabel>Select Answer</InputLabel>
                          <Select
                            value={this.state.answer}
                            onChange={(e) => this.setState({ answer: e.target.value })}
                            name="answer"
                            label="Select Subject"
                            // style={{
                            //   height: "45px",
                            // }}
                            required
                            style={{ width: "100%", height: "45px", color: "#111" }}
                          >
                            <MenuItem value="option1">Option 1</MenuItem>
                            <MenuItem value="option2">Option 2</MenuItem>
                            <MenuItem value="option3">Option 3</MenuItem>
                            <MenuItem value="option4">Option 4</MenuItem>
                          </Select>
                        </Grid>

                        {/* <Grid item sm={6}>
                          <TextField
                            type="file"
                            label="Subject Poster"
                            name="subject_poster"
                            focused
                            onChange={(e) => {
                              this.setState({
                                subject_poster: e.target.files[0],
                              });
                            }}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid> */}

                        {/* <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Testimonial"
                            name="testimonial"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid> */}
                      </Grid>

                      <Grid align="left" mt={2}>
                        {this.state.questionApproved === true ? (
                          <MDButton variant="contained" size="small" color="success" disabled>
                            Approved
                          </MDButton>
                        ) : (
                          <MDButton variant="contained" size="small" color="info" type="submit">
                            {this.state.loading ? "Approving..." : "Approve Question"}
                          </MDButton>
                        )}
                        {/* <MDButton variant="contained" size="small" color="info" type="submit">
                          {this.state.loading ? "Approving..." : "Approve Question"}
                        </MDButton> */}
                      </Grid>
                      <Grid align="left" mt={2}>
                        <MDButton
                          variant="contained"
                          size="small"
                          color="success"
                          onClick={this.handleNext}
                        >
                          {this.state.loading ? "Next" : "Next"}
                        </MDButton>
                      </Grid>
                    </form>
                  </MDBox>
                  <>
                    <MDSnackbar
                      color="success"
                      icon="notifications"
                      title="AgriQuiz Questions"
                      content={this.state.message}
                      dateTime="Just now"
                      open={this.state.notification}
                      //   close={toggleSnackbar}
                    />
                  </>
                </Card>
              </MDBox>
            </DashboardLayout>
          </div>
        </div>
      );
    }
  }
}
